var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8887 0H5.11133C2.29289 0 0 2.29297 0 5.11141V34.8887C0 37.707 2.29289 40 5.11133 40H34.8887C37.7071 40 40 37.707 40 34.8886V5.11141C40 2.29297 37.7071 0 34.8887 0ZM37.6439 34.8887C37.6439 36.408 36.4079 37.6439 34.8887 37.6439H5.11133C3.59203 37.6439 2.35602 36.4079 2.35602 34.8887V30.5912L10.1103 23.9935C10.3933 23.7527 10.8061 23.7505 11.0917 23.9877L15.9491 28.0211C16.4174 28.4099 17.1049 28.378 17.5353 27.9472L29.0766 16.3883C29.2852 16.1793 29.5284 16.159 29.6554 16.1655C29.782 16.172 30.0222 16.2171 30.2084 16.4464L37.644 25.6019V34.8887H37.6439ZM37.6439 21.8645L32.0372 14.9609C31.4812 14.2762 30.657 13.8576 29.7761 13.8123C28.8958 13.7678 28.0326 14.0992 27.4094 14.7234L16.6275 25.522L12.597 22.1752C11.4284 21.2047 9.74055 21.2148 8.58352 22.1992L2.35602 27.4978V5.11141C2.35602 3.59211 3.59203 2.35609 5.11133 2.35609H34.8887C36.408 2.35609 37.6439 3.59211 37.6439 5.11141V21.8645Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5918 4.9209C9.45941 4.9209 6.91113 7.46934 6.91113 10.6016C6.91113 13.7339 9.45949 16.2823 12.5918 16.2823C15.7242 16.2823 18.2725 13.7339 18.2725 10.6016C18.2725 7.46926 15.7243 4.9209 12.5918 4.9209ZM12.5918 13.9263C10.7586 13.9263 9.26715 12.4348 9.26715 10.6016C9.26715 8.76832 10.7586 7.27691 12.5918 7.27691C14.4251 7.27691 15.9165 8.7684 15.9165 10.6016C15.9165 12.4348 14.4251 13.9263 12.5918 13.9263Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.85a352af9f9e567a6fd83cead626d923.svg";
export { ForwardRef as ReactComponent };